import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import CaseTypeDetail from './CaseTypeDetail';

interface Props {
	isOpened: boolean;
	onClose: () => void;
	onSuccess: (canBookOnline: boolean) => void;
	onRemove: () => void;
	caseTypeId?: string;
	workplaceId: string;
	isOnlyOneRoot: boolean;
}

const CaseTypeDetailModal: React.FC<Props> = ({
	isOpened,
	onClose,
	onSuccess,
	caseTypeId,
	workplaceId,
	isOnlyOneRoot,
	onRemove,
}) => {
	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.MD}>
			<Modal.Header
				title={
					caseTypeId
						? 'component.caseType.editCaseType'
						: 'component.caseType.addCaseType'
				}
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<CaseTypeDetail
					caseTypeId={caseTypeId}
					onSuccess={onSuccess}
					onRemove={onRemove}
					workplaceId={workplaceId}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default CaseTypeDetailModal;
